import EventEmitter from 'events';

export enum EMITTER_EVENTS {
  BODY_KEYDOWN = 'body_keydown',
  CLOSE_CELL_EDIT_MODE = 'close_cell_edit_mode',
}

export const eventEmitter = new EventEmitter();
// eslint-disable-next-line jest/require-hook
eventEmitter.setMaxListeners(1000); // by default 10
